// src/index.js 
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, useNavigate } from 'react-router-dom';
import App from './App';
import { Auth0Provider } from '@auth0/auth0-react';

// Create a wrapper to include useNavigate inside Auth0Provider
const Auth0WithRouter = () => {
  const navigate = useNavigate();

  return (
    <Auth0Provider
      domain="dev-at2xn47qq3pfzzs5.eu.auth0.com"
      clientId="xArzYPPEZ5UBCtx2h9iMBAZsa19fBa3F"
      authorizationParams={{
        redirect_uri: window.location.origin + '/login', // Redirect to /login to handle errors
      }}
      onRedirectCallback={(appState) => {
        navigate(appState?.returnTo || '/');
      }}
      // Other Auth0 configurations if necessary
    >
      <App />
    </Auth0Provider>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Auth0WithRouter />
    </BrowserRouter>
  </React.StrictMode>
);
